<template>
  <div>
    <div class="adviser-com" v-if="!!total">
      <div class="title">精选顾问</div>
      <div class="adviser-wrap">
        <template v-for="(item, index) in advisers">
          <adviser class="adviser" :class="{ml20: (index + 1)%3 === 0 || 2, last2: last2(index) }" :key="index" v-if="index < 9 || isWatchMore" :info="item"></adviser>
        </template>
      </div>
      <div class="watch-more" v-if="total > 9" @click="isWatchMore = !isWatchMore">{{ watchMoreText }}</div>
    </div>
    <div class="adviser-com" v-else>
      <div class="title">精选顾问</div>
      <div class="noData">暂无数据</div>
    </div>
  </div>
</template>

<script>
import adviser from './adviser.vue'
export default {
  name: 'adviser-com',
  components: {
    adviser
  },
  props: {
    projectCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      advisers: [],
      total: 0,
      isWatchMore: false
    }
  },
  computed: {
    watchMoreText () {
      return this.isWatchMore ? '收起' : `查看所有顾问（${this.total}）`
    }
  },
  methods: {
    last2 (index) {
      const list = this.advisers
      const isDoubleNum = list && list.length % 2 === 0
      const last2 = isDoubleNum ? [(list && list.length) - 1, (list && list.length) - 2].includes(index) : index === (list && list.length) -1
      return last2
    },
    async getAdvisers () {
      let params = {
        isOpenUserConsultSwitch: 1,
        projectCode: this.projectCode,
        limit: 100,
      }
      const { data } = await this.$api.getAdvisers(params)
      this.advisers = data.list
      this.total = data.total
      this.$emit('advisersData', data);
    }
  },
  mounted () {
    this.getAdvisers()
  },
}
</script>
<style lang="scss" scoped>
  .title{
    @include font24(bold, #333333);
    margin: 52px 0 16px 0;
  }
  .noData{
    width: 126px;
    height: 19px;
    font-size: 14px;
    font-family: MicrosoftYaHeiSemilight;
    color: #B4A995;
    line-height: 19px;
    margin: auto;
    padding: 100px 50px;
  }
  .adviser-wrap{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 20px;
    .ml20{
      margin-right: 40px;
    }
    .adviser{
      margin-top: 10px;
      // border-bottom: 1px solid #D8D8D8;
    }
    // .last2{
    //   border-bottom: none;
    // }
  }
  .watch-more{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #E6E6E6;
    cursor: pointer;
  }
</style>
